export default [
    {
        title: 'Article',
        customIcon: 'ArticleSVG',
        children: [
            {
                title: 'Article List',
                route: 'article-list',
                path: '/article/article/list',
            },
            {
                title: 'Article Category',
                route: 'article-category',
                path: '/article/article/category',
            }
        ]
    }
]